import * as React from "react";
import { InputError } from "./InputError";
import { InputLabel } from "./InputLabel";

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	name: string;
	label?: null | string;
	error?: null | boolean | string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ name, label, error, style, onFocus, onBlur, ...props }, ref) => (
		<>
			{label && <InputLabel name={name} content={label} />}
			<input
				id={`${name}-input`}
				name={name}
				ref={ref}
				style={{
					display: "block",
					width: "100%",
					height: 36,
					padding: "0 12px",
					fontSize: 14,
					fontFamily: "var(--font-sans)",
					color: "var(--content-primary)",
					background: "var(--surface-default)",
					border: `1px solid ${error ? "var(--accent-error)" : "var(--border-default)"}`,
					borderRadius: "var(--radius-md)",
					outline: "none",
					transition: "border-color 0.15s",
					boxSizing: "border-box",
					...style,
				}}
				onFocus={(e) => {
					e.currentTarget.style.borderColor = error
						? "var(--accent-error-dark)"
						: "var(--accent-500)";
					onFocus?.(e);
				}}
				onBlur={(e) => {
					e.currentTarget.style.borderColor = error
						? "var(--accent-error)"
						: "var(--border-default)";
					onBlur?.(e);
				}}
				{...props}
			/>
			{typeof error === "string" && <InputError content={error} />}
		</>
	),
);

Input.displayName = "Input";
